import styled from 'styled-components';

import { mediaQueryLaptopMin } from '@/styleUtils';

const Wrapper = styled.aside`
  padding-top: 32px;
  width: 100%;

  @media ${mediaQueryLaptopMin} {
    width: 300px;
  }
`;

export default Wrapper;
